import React from 'react';

const Snackbar = ({ isOpen, message, type = 'success', onClose }) => {
  if (!isOpen) return null;

  const typeClasses = {
    success: 'bg-green-300 text-white',
    error: 'bg-red-300 text-white',
    warning: 'bg-yellow-300 text-white',
    info: 'bg-blue-300 text-white'
  };

  return (
    <div className="fixed top-4 right-5 z-50">
      <div className={`px-4 py-3 rounded-lg shadow-lg ${typeClasses[type]} flex items-center gap-3`}>
        <span className="text-sm font-medium">{message}</span>
        <button
          onClick={onClose}
          className="text-white hover:text-gray-200 transition-colors"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default Snackbar;
